import { Component, Input, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'concessionario-pessoa-fisica',
  templateUrl: './concessionario-pessoa-fisica.component.html',
  styleUrls: ['./concessionario-pessoa-fisica.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class ConcessionarioPessoaFisicaComponent implements OnInit {
  
  @Input() tpConcessao: number;

  constructor() {}

  ngOnInit() {}

}
